import { getCookieValue } from '@utils/cookie'
import { PageMetadata } from '@hooks/usePageMetadata'

import {
  VideoPlayerStatus,
  PlayerType,
  PlayerStatusTracking,
  TrackingGetPlayerStatusProps,
} from '../../types/darkcove'

import { getPlayerType } from '../../utils'
import { captureException } from '@utils/sentry'

interface VideoMainElementTrackingValues {
  videoId: string
  duration: number
  videoTitle: string
  playerType: PlayerType
}

export const getVideoMainElementTrackingValues = (
  pageMetadata: PageMetadata
): VideoMainElementTrackingValues | object => {
  const videoMainElement = pageMetadata?.teaser?.video

  if (!videoMainElement) {
    return {}
  }

  return {
    videoId: videoMainElement?.videoId,
    duration: videoMainElement?.duration,
    videoTitle: videoMainElement?.title,
    playerType: getPlayerType({
      isBlickTV: false,
      duration: videoMainElement?.duration,
    }),
  }
}

export const getPlayerStatus = ({
  isFloatingBlickTV,
  playerRef,
  setDispatchTrackingEvents,
  createDispatchFutureStateFunction,
}: TrackingGetPlayerStatusProps): PlayerStatusTracking => {
  const playerStatus = playerRef.current?.getPlayerStatus?.()
  if (playerStatus) {
    const { audio, captions, mode: playerMode } = playerStatus
    if (isFloatingBlickTV) {
      // TODO: revise this logic
      setDispatchTrackingEvents(
        createDispatchFutureStateFunction({
          audio,
          captions,
          playerMode,
        })
      )
    }
    return {
      audio,
      captions,
      playerMode,
    }
  } else {
    console.error('Could not get player status')
    captureException({ message: 'Could not get player status', playerStatus })
    return null
  }
}

export const shouldLogBlickTV = getCookieValue('BLICKTVLOG')

export const withBlickTVLog = (trackFn: (args?: any) => any) =>
  shouldLogBlickTV && trackFn.name !== 'onProgress'
    ? (...args: any) => {
        console.log('============================')
        console.log(trackFn.name)
        console.table(args) // || console.log(args)
        console.log('============================')
        return trackFn(...args)
      }
    : trackFn

export const extractErrorObj = ({ error }: any) => error

// TODO: do we need this???
// Firebase on Android is stripping out values that are false
// This will transform the boolean values to string values, so that we
// are able to keep the information about captions and audio
export const transformCaptionsAndAudioValue = (payload: VideoPlayerStatus) => {
  return {
    ...payload,
    captions: payload.captions ? '1' : '0',
    audio: payload.audio ? '1' : '0',
  }
}
